import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { FETCHING_STATUS } from '../../types';

type ConferenceHistoryFetchingState = {
    status: FETCHING_STATUS | null;
};

const initialState: ConferenceHistoryFetchingState = {
    status: null,
};

const conferencesHistoryFetchingSlice = createSlice({
    name: 'conferenceHistoryFetchingSlice',
    initialState,
    reducers: {
        setFetchingStatus(state: ConferenceHistoryFetchingState, { payload }: PayloadAction<FETCHING_STATUS | null>) {
            state.status = payload;
        },
    },
});

export const { setFetchingStatus } = conferencesHistoryFetchingSlice.actions;
export const conferencesHistoryFetchingReducer = conferencesHistoryFetchingSlice.reducer;
